var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#E4DCF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63384 8.15478C8.06136 9.04522 8.64417 9.87978 9.38225 10.6179C10.1203 11.3559 10.9549 11.9387 11.8453 12.3663C11.9219 12.403 11.9602 12.4214 12.0087 12.4356C12.1809 12.4858 12.3923 12.4497 12.5382 12.3453C12.5792 12.3159 12.6143 12.2808 12.6846 12.2105C12.8993 11.9958 13.0067 11.8884 13.1147 11.8182C13.5218 11.5535 14.0468 11.5535 14.454 11.8182C14.5619 11.8884 14.6693 11.9958 14.8841 12.2105L15.0038 12.3302C15.3302 12.6567 15.4934 12.8199 15.5821 12.9952C15.7584 13.3438 15.7584 13.7556 15.5821 14.1042C15.4934 14.2795 15.3302 14.4427 15.0038 14.7692L14.9069 14.866C14.5816 15.1913 14.4189 15.354 14.1978 15.4782C13.9524 15.6161 13.5712 15.7152 13.2898 15.7143C13.0361 15.7136 12.8628 15.6644 12.516 15.566C10.6528 15.0371 8.89452 14.0393 7.42769 12.5724C5.96085 11.1056 4.963 9.34735 4.43414 7.48406C4.33573 7.13734 4.28653 6.96398 4.28577 6.71033C4.28493 6.42886 4.38405 6.04772 4.5219 5.80232C4.64614 5.58117 4.8088 5.4185 5.13413 5.09318L5.23095 4.99635C5.5574 4.6699 5.72062 4.50668 5.89592 4.41802C6.24455 4.24168 6.65626 4.24168 7.00489 4.41802C7.18019 4.50668 7.34341 4.6699 7.66986 4.99635L7.78956 5.11605C8.00431 5.3308 8.11168 5.43817 8.18188 5.54614C8.44662 5.95333 8.44662 6.47827 8.18188 6.88545C8.11168 6.99343 8.00431 7.1008 7.78956 7.31555C7.71934 7.38577 7.68423 7.42087 7.65484 7.46191C7.55041 7.60776 7.51435 7.81922 7.56455 7.99143C7.57868 8.03989 7.59707 8.07819 7.63384 8.15478Z",
    stroke: "#492897",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.1d078e025682bf433f55cb598dc6cc13.svg";
export { ForwardRef as ReactComponent };